import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openPanelAction, closePanelAction } from '../actions/overlayActions';
import { getPanelType } from '../selectors/overlaySelectors';
import { EDIT_CARDS_PANEL, FILTER_PANEL, OBJECT_BUILDER_PANEL, LEGACY_OBJECT_BUILDER_PANEL, PRODUCT_CREATE_PANEL, COLUMN_INSIGHTS_PANEL } from '../constants/panelTypes';
import { trackOpenMoreFiltersPanel } from '../../tracking/indexPageTracking';
export const usePanelActions = () => {
  const dispatch = useDispatch();
  const panelType = useSelector(getPanelType);
  const openPanel = useCallback((type, data) => dispatch(openPanelAction(type, data)), [dispatch]);
  const closePanel = useCallback(() => dispatch(closePanelAction()), [dispatch]);
  const openFilterPanel = useCallback(() => {
    if (panelType !== FILTER_PANEL) {
      trackOpenMoreFiltersPanel();
    }
    openPanel(FILTER_PANEL);
  }, [openPanel, panelType]);
  const openObjectBuilderPanel = useCallback(() => openPanel(OBJECT_BUILDER_PANEL), [openPanel]);
  const openLegacyObjectBuilderPanel = useCallback(legacyObjectBuilderWrapperProps => openPanel(LEGACY_OBJECT_BUILDER_PANEL, legacyObjectBuilderWrapperProps), [openPanel]);
  const openEditCardsPanel = useCallback(tabId => openPanel(EDIT_CARDS_PANEL, {
    tabId
  }), [openPanel]);
  const openProductCreatePanel = useCallback((readOnly, onClose) => openPanel(PRODUCT_CREATE_PANEL, {
    readOnly,
    onClose
  }), [openPanel]);
  const openColumnInsightsPanel = useCallback((columnName, filterGroups, objectTypeId, query) => openPanel(COLUMN_INSIGHTS_PANEL, {
    columnName,
    filterGroups,
    objectTypeId,
    query
  }), [openPanel]);
  return {
    openFilterPanel,
    openObjectBuilderPanel,
    openLegacyObjectBuilderPanel,
    openEditCardsPanel,
    openProductCreatePanel,
    openColumnInsightsPanel,
    closePanel
  };
};